export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./UserGroupPermissions.vue?vue&type=template&id=7f381386&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Dashboard/Pages/UserGroupPermissions.vue?vue&type=template&id=7f381386&scoped=true
// module id = 2272
// module chunks = 31